import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useCrmFacebookLeadFormField = () =>
  useQuery<crmModels.ICrmField[]>({
    queryKey: [crmConstants.queryKeys.CRM_FACEBOOK_LEAD_FORM_FIELD],
    queryFn: async () => {
      const res = await $api.get('/v1/crm/facebook/lead-form/field');

      return res?.data?.data;
    }
  });
